import { CALL_API } from "constants/api";
import { IProgressive } from "reducers/base-reducers";
import { add as snackbarAdd } from "./snackbars";
import { format } from "lib/globalize-util";
import upperFirst from "lodash/upperFirst";

export function fetch(TYPE: IProgressive, endpoint: string) {
    return {
        [CALL_API]: {
            types: [TYPE.START, TYPE.SUCCESS, TYPE.ERROR],
            endpoint,
        },
    };
}

export function checkStatus(dispatch, status: number, body) {
    if (status === 401) {
        return false; // redirect without an error message
    } else if (status < 200 || status >= 300) {
        const message =
            body && body.message
                ? upperFirst(body.message)
                : format("Oops! Something went wrong. Please refresh and try again.");
        dispatch(snackbarAdd({ message }));
        return false;
    }
    return true;
}
